import { mapEnum } from 'utils/global';
import { TypeOfIdentification } from '__generated__/api';

export const filteredTypeOfIdentification: string[] = mapEnum(TypeOfIdentification).filter(
  (item: string) =>
    item === TypeOfIdentification.EuropeanID || item === TypeOfIdentification.Passport
);
